import React from 'react';

import { graphql, useGqlContext } from '@search/gql-client/src';
import {
    UnsubscribeSearchMutation$data as UnsubscribeSearchMutationResponse, UnsubscribeSearchMutation$variables as UnsubscribeSearchMutationVariables
} from './__generated__/UnsubscribeSearchMutation.graphql';

const UnsubscribeSearchMutation = graphql`
  mutation UnsubscribeSearchMutation($searchIds: [ID!]!, $userId: ID!) {
    unsubscribeFromSearchOpen(searchIds: $searchIds, userId: $userId) {
        isUnsubscribed
        firstError {
            __typename
            ... on BaseError {
                message
            }
            ... on AuthUserIdError {
                message
            }
            ... on UnsubscribeFromSearchErrorInvalidId {
                message
            }
            ... on UnsubscribeFromSearchErrorNotExists {
                message
            }
        }
    }
  }
`;

export const useUnsubscribeSearchMutation = () => {
    const gql = useGqlContext();

    return React.useCallback((props: UnsubscribeSearchMutationVariables) => {
        return gql.client<UnsubscribeSearchMutationVariables, UnsubscribeSearchMutationResponse>(
            UnsubscribeSearchMutation,
            props
        );
    }, [ ]);
};
